import { createSelector, createSlice } from '@reduxjs/toolkit';

export const icalendarFilterSlice = createSlice({
    name: 'icalendarFilter',
    initialState: {
        // Filter values
        userId: 'all',
        group: 'all',
        asset: 'all',
        origins: 'all',
        origin: 'all', // Support single origin parameter
        status: 'all',
        substatus: 'all',
        model: 'all',
        organization: 'all',
        search: '',

        // Date range filters
        startDate: '',
        endDate: '',
        range: 'all',

        // UI state
        isLoadingOrgs: true,
        isHQ: false,
        organizationId: null,
        childrenOrganizations: [],

        agents: [],
        groups: [],
    },
    reducers: {
        setFilterValue: (state, action) => {
            const { key, value } = action.payload;
            state[key] = value;
        },
        setMultipleFilters: (state, action) => {
            const filters = action.payload;
            Object.keys(filters).forEach((key) => {
                if (state.hasOwnProperty(key)) {
                    state[key] = filters[key];
                }
            });
            
            // Handle both origins and origin parameters
            if (filters.hasOwnProperty('origins')) {
                state.origins = filters.origins;
            }
            if (filters.hasOwnProperty('origin')) {
                state.origin = filters.origin;
            }
        },
        setOrganizationData: (state, action) => {
            const { organizationId, isHQ, childrenOrganizations, isLoadingOrgs } = action.payload;
            state.organizationId = organizationId;
            state.isHQ = isHQ;
            state.childrenOrganizations = childrenOrganizations;
            state.isLoadingOrgs = isLoadingOrgs;
        },
        resetFilters: (state) => {
            state.userId = 'all';
            state.group = 'all';
            state.asset = 'all';
            state.origins = 'all';
            state.origin = 'all';
            state.status = 'all';
            state.substatus = 'all';
            state.model = 'all';
            state.organization = 'all';
            state.search = '';
            state.startDate = '';
            state.endDate = '';
            state.range = 'all';
            state.hasUserGroupIdChanged = false;
        },
        resetOrganizationFilters: (state) => {
            state.group = 'all';
            state.asset = 'all';
            state.userId = 'all';
            state.origins = 'all';
            state.origin = 'all';
        },
        setAgents: (state, action) => {
            state.agents = action.payload;
        },
        setGroups: (state, action) => {
            state.groups = action.payload;
        },
    },
});

export const {
    setFilterValue,
    setMultipleFilters,
    setOrganizationData,
    resetFilters,
    resetOrganizationFilters,
    setAgents,
    setGroups,
} = icalendarFilterSlice.actions;

// Selectors
export const getFilterValue = (state, key) => state.icalendarFilter[key];
export const getAllFilters = (state) => state.icalendarFilter;
export const getGroups = (state) => state.icalendarFilter.groups;

// Memoized selector for organization data
export const getOrganizationData = createSelector([(state) => state.icalendarFilter], (filterState) => ({
    organizationId: filterState.organizationId,
    isHQ: filterState.isHQ,
    childrenOrganizations: filterState.childrenOrganizations,
    isLoadingOrgs: filterState.isLoadingOrgs,
}));

export default icalendarFilterSlice.reducer;
